import { hooks } from 'botframework-webchat';
import { useCallback } from 'react';
const { useSendEvent } = hooks;
const answerFeedbackEventName = 'answerFeedback';
export const useSendAnswerFeedback = (answerActivity) => {
    var _a, _b, _c;
    const sendEvent = useSendEvent();
    const channelData = (answerActivity.channelData || {});
    const sourceActivityId = (_a = answerActivity.id) !== null && _a !== void 0 ? _a : '';
    const sourceIntentId = (_c = (_b = channelData.allowedFeedback) === null || _b === void 0 ? void 0 : _b.intentId) !== null && _c !== void 0 ? _c : '';
    return useCallback((feedback) => {
        const event = {
            name: answerFeedbackEventName,
            value: {
                sourceActivityId,
                sourceIntentId,
                feedback
            }
        };
        sendEvent(event.name, event.value);
    }, [sourceIntentId, sourceActivityId]);
};
//# sourceMappingURL=useSendAnswerFeedback.js.map